import * as React from 'react';

import useOperatingSystem from '@/hooks/useOperatingSystem';
import { cn } from '@/lib/utils';

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {}

const Kbd = ({ className, ref, ...props }: KbdProps & { ref?: React.Ref<HTMLElement> }) => {
  return (
    <kbd
      ref={ref}
      className={cn(
        'pointer-events-none inline-flex h-5 items-center gap-1 rounded border bg-subtle px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100 select-none',
        className
      )}
      {...props}
    />
  );
};

const KEY_DISPLAY: Record<string, string> = { bracketleft: '[' };

const getDisplayKey = (shortcut: string) => {
  const key = shortcut.split('+').pop() ?? '';
  return KEY_DISPLAY[key] ?? key.toUpperCase();
};

export const useShortcutLabel = (shortcut: string) => {
  const { optionKey } = useOperatingSystem();
  return `${optionKey} + ${getDisplayKey(shortcut)}`;
};

interface ShortcutHintProps {
  shortcut: string;
  className?: string;
  kbdClassName?: string;
}

const ShortcutHint = ({ shortcut, className, kbdClassName }: ShortcutHintProps) => {
  const { optionKey } = useOperatingSystem();

  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <Kbd className={kbdClassName}>{optionKey}</Kbd>
      <Kbd className={kbdClassName}>{getDisplayKey(shortcut)}</Kbd>
    </span>
  );
};

export { Kbd, ShortcutHint };
